export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAIL = 'FETCH_FAIL';
export const CONVERT_GRAVES = 'CONVERT_GRAVES';
export const UPDATE_CURRENT_POSITION = 'UPDATE_CURRENT_POSITION';
export const UPDATE_ClOSEST_POSITION = 'UPDATE_ClOSEST_POSITION';
export const UPDATE_CURRENT_POSITION_INBOUNDS =
  'UPDATE_CURRENT_POSITION_INBOUNDS';
export const ALERT_OPEN = 'ALERT_OPEN';
export const SHARE_PATH = 'SHARE_PATH';
export const FETCH_SHARED = 'FETCH_SHARED';
export const FETCH_SHARED_SUCCESS = 'FETCH_SHARED_SUCCESS';
export const FETCH_SHARED_FAIL = 'FETCH_SHARED_FAIL';
export const SHOW_PATH = 'SHOW_PATH';
export const SELECT_GRAVE = 'SELECT_GRAVE';
export const SET_CEMETERY = 'SET_CEMETERY';

export const fetch = () => {
  return {
    type: FETCH_REQUEST,
  };
};

export const convert = (map, layers) => {
  return {
    type: CONVERT_GRAVES,
    layers,
    map,
  };
};

export const updatePosition = (pos) => {
  return {
    type: UPDATE_CURRENT_POSITION,
    position: pos,
  };
};

export const updatePositionBounds = (inBounds) => {
  return {
    type: UPDATE_CURRENT_POSITION_INBOUNDS,
    inBounds,
  };
};

export const updateClosestPosition = (pos) => {
  return {
    type: UPDATE_ClOSEST_POSITION,
    position: pos,
  };
};

export const checkIfAlertOpened = (isOpened) => {
  return {
    type: ALERT_OPEN,
    opened: isOpened,
  };
};

export const onSharePath = (hash, graves) => {
  return {
    type: SHARE_PATH,
    hash,
    graves,
  };
};

export const fetchSharedPath = (hash) => {
  return {
    type: FETCH_SHARED,
    hash,
  };
};

export const showPath = (path, pathToPath) => {
  return {
    type: SHOW_PATH,
    path,
    pathToPath,
  };
};

export const selectGrave = (grave) => {
  return {
    type: SELECT_GRAVE,
    grave,
  };
};

export const setCemetery = (cemetery) => {
  return {
    type: SET_CEMETERY,
    cemetery,
  };
};



// WEBPACK FOOTER //
// ./src/js/redux/actions.js